import { getImageUrl } from "helpers";


const AboutTeamItem = ({ data }) => {

    const { image, name, position } = data
    const Image = getImageUrl(image)

    return (
        <div className="about-team-item">
            <div className="about-team-item__image">
                <img src={Image} alt="" />
            </div>
            <div className="about-team-item__body">
                <div className="body1">{name}</div>
                <div className="link">{position}</div>
            </div>
        </div>
    );
}

export default AboutTeamItem;